import AdFormService from "../../common/ts/services/AdFormService";
import {EventBus} from "../../common/ts/events/EventBus";
import {Section} from "../../common/ts/services/Section";
import {
    ContactModalFormDisplayedEvent,
    FullPageModalOpenEvent,
    SerpSnippetContactButtonClickedEvent,
    SerpSnippetContactButtonClickedEventPayload,
    WhitelabelEvent
} from "../../common/ts/events/Events";
import HipflatForm from "./HipflatForm";
import PageData from "../../common/ts/PageData";

export default class HipflatSerpCTAs {
    private readonly eventBus: EventBus;
    private adFormService: AdFormService = new AdFormService();
    private readonly serpContactModalId = "contact-modal"
    private readonly form: HipflatForm

    constructor(pageData: PageData, adContactForm: HTMLElement) {
        this.eventBus = EventBus.getInstance();
        this.form = HipflatForm.initForm(adContactForm as HTMLElement, pageData)
        this.setupEvents(pageData);
    }

    static init(pageData: PageData) {
        const form = document.getElementById("contact-modal")?.querySelector('#adform-contact-form');
        if(form != null) {
            new HipflatSerpCTAs(pageData, form as HTMLElement)
        }
    }

    private setupEvents(pageData: PageData) {
        document.querySelectorAll(".js-snippet-cta-contact-form")
            .forEach(button => {
                button.addEventListener('click', (event) => {
                    const currentButton = event.currentTarget as HTMLElement;
                    const dataset = currentButton?.dataset;
                    this.eventBus.emit(new SerpSnippetContactButtonClickedEvent({
                        step: 2,
                        section: Section.SECTION_SEARCH_AD_CONTACT_FORM,
                        listingId: atob(dataset.lid as string),
                        pageViewId: pageData.pageViewId,
                        pageViewType: pageData.pageViewType,
                        showOperationSelector: Boolean(dataset.sos),
                        showRentDatePicker: Boolean(dataset.srdp),
                    }))
                });
            });

        this.eventBus.subscribe(SerpSnippetContactButtonClickedEvent.TYPE, (event: WhitelabelEvent) => {
            const payload: SerpSnippetContactButtonClickedEventPayload = (event as SerpSnippetContactButtonClickedEvent).payload;
            this.openContactModal(
                payload.section,
                payload.listingId,
                payload.pageViewId,
                payload.step,
                payload.pageViewType,
                payload.showOperationSelector,
                payload.showRentDatePicker,
            );
        });
    }

    private openContactModal(
        section: Section,
        propertyAdId: string,
        pageViewId: string,
        step: number,
        pageViewType: string,
        showOperationSelector: boolean,
        showRentDatePicker: boolean,
    ) {
        const contactModal = document.getElementById(this.serpContactModalId);
        if (contactModal) {
            this.initializeModalForm(contactModal, showOperationSelector, showRentDatePicker)
        }

        this.form.reset();
        this.form.listingId = propertyAdId;
        this.eventBus.emit(new FullPageModalOpenEvent({id: this.serpContactModalId}));
        this.adFormService.sendApplyImpression({
            pageViewId: pageViewId,
            propertyAdId: propertyAdId,
            section: section,
            step: step,
            isProject: false,
        });
        this.eventBus.emit(new ContactModalFormDisplayedEvent({
            section: section,
            propertyAdId: propertyAdId,
            pageViewId: pageViewId,
            step: step,
            pageViewType: pageViewType,
        }));
    }

    private initializeModalForm(contactModal: HTMLElement, showOperationSelector: boolean, showRentDatePicker: boolean) {
        const showOperationSelectorElement = contactModal.querySelector(".js-show-operation-selector") as HTMLElement;
        if (showOperationSelectorElement && showOperationSelector) {
            showOperationSelectorElement.style.display = "flex"
            let saleOperationSelector = contactModal.querySelector('.js-operation-type.sale') as HTMLInputElement;
            saleOperationSelector.checked = true
        } else {
            showOperationSelectorElement.style.display = "none"
        }
        const showRentDatePickerElement = contactModal.querySelector(".js-show-rent-date-picker") as HTMLElement;
        if (showRentDatePickerElement && showRentDatePicker && !showOperationSelector) {
            showRentDatePickerElement.classList.remove("hide")
        } else {
            showRentDatePickerElement.classList.add("hide")
        }
        if ((contactModal.querySelector(".js-operation-type.operation") as HTMLInputElement).value == "RENT") {
            (contactModal.querySelector("#operation-type-rent-contact-modal-form") as HTMLInputElement).click();
        }
    }
}
